/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1902018573 — NotSupportedScreen */

import { useTranslation } from 'react-i18next';

import { ContentBox, ScreenTitle, ScreenWrapper } from '../../../../shared/ui';
import { AnimatedIcon } from '../../../../shared/ui/AnimatedIcon/AnimatedIcon';
import quarkAnimation from '../../../../shared/ui/AnimatedIcon/animations/quark.json';
import { usePageTracking } from '../../../../shared/hooks/usePageTracking';
import styles from './NotSupportedScreen.module.css';

export const NotSupportedScreen = () => {
    const { t } = useTranslation();

    usePageTracking('not supported');

    return (
        <ScreenWrapper>
            <ScreenTitle>{t('Payment not supported')}</ScreenTitle>
            <ContentBox>
                <div className={styles.wrapper}>
                    <AnimatedIcon
                        animationData={quarkAnimation}
                        loop={false}
                        className={styles.animationWrapper}
                    />
                </div>
                <div className={styles.message}>
                    {t('Payment not supported.description_1')}
                </div>
            </ContentBox>
        </ScreenWrapper>
    );
};
